import React from 'react';
import styled from 'styled-components';
import CandidateItem from './item';
import { grid } from './constants';
import Title from './title';
import { CandidateListProps, InnerCandidateListProps, InnerListProps } from '../types';

const Wrapper = styled.div`
  display: flex;
  padding: ${grid}px;
  border: none;
  border-bottom-left-radius: ${grid}px;
  border-bottom-right-radius: ${grid}px;
  padding-bottom: 0;
  min-height: 150px;
`;

const scrollContainerHeight = "auto";

const DropZone = styled.div`
  display: flex;
  width: 100%;
  min-height: ${scrollContainerHeight}px;
  padding-bottom: ${grid}px;
`;

const ScrollContainer = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  width: inherit;
`;

const Container = styled.div`
  width: inherit;
  display: flex;
`;

const InnerCandidateList = React.memo(function InnerCandidateList(
  props: InnerCandidateListProps
) {
  return (
    <div className='d-flex'>
      {props?.candidates?.map((candidate: any, index: number) => (
        <CandidateItem
          key={candidate._id}
          candidate={candidate}
          index={index}
          colors={props.colors}
        />
      ))}
    </div>
  );
});

function InnerList(props: Readonly<InnerListProps>) {
  const { candidates, colors } = props;
  const title = props.title ? <Title>{props.title}</Title> : null;
  return (
    <Container>
      {title}
      <DropZone>
        <InnerCandidateList candidates={candidates} colors={colors} />
      </DropZone>
    </Container>
  );
}

export default function CandidateList(props: Readonly<CandidateListProps>) {
  const {
    internalScroll,
    style,
    candidates,
    title,
    colors,
  } = props;

  return (
    <Wrapper
      style={style}
    >
      {internalScroll ? (
        <ScrollContainer>
          <InnerList candidates={candidates} title={title} colors={colors} />
        </ScrollContainer>
      ) : (
        <InnerList candidates={candidates} title={title} colors={colors} />
      )}
    </Wrapper>
  );
}
